import type { LegacyTrait } from '@warp-drive/core/types/schema/fields';

const CommentableTraitSchema = {
  name: 'commentable',
  mode: 'legacy',
  fields: [
    {
      kind: 'hasMany',
      name: 'comments',
      type: 'comment',
      options: {
        async: false,
        inverse: 'commentable',
        as: 'commentable',
      },
    },
  ],
} satisfies LegacyTrait;

export default CommentableTraitSchema;
